import { Directive, Input, OnChanges } from '@angular/core';
import { NgControl } from "@angular/forms";

@Directive({selector: '[disableProp]'}) 
export class DisablePropDirective {

    constructor(private _this: NgControl) { }

    @Input('disableProp') set disable(cond: boolean) {
        if (cond) this._this.control.disable(); else this._this.control.enable();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/disabled-prop.directive.ts